export const KEYBOARD_MODE_CSS_VAR: App.Design.CSSVar = '--app-keyboard-mode'
export const MOUSE_MODE_CSS_VAR: App.Design.CSSVar = '--app-mouse-mode'
export const TOUCH_MODE_CSS_VAR: App.Design.CSSVar = '--app-touch-mode'
